module.exports = __webpack_public_path__ + "img/vinci.10dcc179.jpg";